import { render, staticRenderFns } from "./HeaderPopup.vue?vue&type=template&id=906c03e8&scoped=true"
import script from "./HeaderPopup.vue?vue&type=script&lang=js"
export * from "./HeaderPopup.vue?vue&type=script&lang=js"
import style0 from "./HeaderPopup.vue?vue&type=style&index=0&id=906c03e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c03e8",
  null
  
)

export default component.exports